import { useEffect, useState } from "react";
/** Grenzen aus dem Entwurf. Bewusst Zahlen statt Gerätenamen — sie gelten auch für Fenster. */
export const BREAKPOINT_TABLET = 744;
export const BREAKPOINT_DESKTOP = 1280;
export function classifyWidth(breite) {
    if (breite >= BREAKPOINT_DESKTOP)
        return "desktop";
    if (breite >= BREAKPOINT_TABLET)
        return "tablet";
    return "phone";
}
/**
 * Rohe Fensterbreite in Pixeln. AppShell braucht sie zusätzlich zur Größenklasse, um auf
 * dem iPad zwischen Drängen und Überlagern zu unterscheiden (siehe BREAKPOINT_OVERLAY in
 * AppShell.tsx) — dafür reicht "tablet" als grobe Klasse nicht, es kommt auf die genaue
 * Breite innerhalb der Klasse an.
 */
export function useWindowWidth() {
    const [breite, setBreite] = useState(() => typeof window === "undefined" ? BREAKPOINT_DESKTOP : window.innerWidth);
    useEffect(() => {
        const beiAenderung = () => setBreite(window.innerWidth);
        beiAenderung();
        window.addEventListener("resize", beiAenderung);
        return () => window.removeEventListener("resize", beiAenderung);
    }, []);
    return breite;
}
export function useSizeClass() {
    return classifyWidth(useWindowWidth());
}
//# sourceMappingURL=useSizeClass.js.map